import * as React from 'react';
import classNames from 'classnames';
import s from './PageFooter.scss';
import { useTranslation } from 'react-i18next';
import { Text } from 'wix-style-react';
import { useBreakpoint } from 'providers/BreakpointProvider';
import { MediaDevices } from 'enums';

interface SSLSecurePaymentProps {
  isJapanesePackagePicker?: boolean;
}
export const SSLSecurePayment: React.FC<SSLSecurePaymentProps> = ({
  isJapanesePackagePicker,
}) => {
  const { t } = useTranslation();
  const { currentBreakpoint } = useBreakpoint();
  const titleKey =
    currentBreakpoint !== MediaDevices.Desktop
      ? 'page_footer.ssl_secure_payment.tablet'
      : 'page_footer.ssl_secure_payment';

  return (
    <div className={s.singleElementWrapper}>
      <div className={s.singleElement}>
        <div className={s.sideIconContainer}>
          <i className={s.securePaymentIcon} />
          <div>
            <Text weight='bold' size='tiny' tagName='p' className={s.title}>
              {t(titleKey)}
            </Text>
            <Text
              weight='thin'
              size='tiny'
              tagName='p'
              className={classNames(s.desc, {
                [s.japan]: isJapanesePackagePicker,
              })}
            >
              {t('page_footer.information_encryption')}
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
};
